import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function PageHero({ eyebrow, title, description, breadcrumb }) {
  return (
    <section className="relative bg-gradient-to-br from-navy via-navy-800 to-navy-900 pt-32 sm:pt-36 pb-16 sm:pb-20 overflow-hidden">
      <div className="absolute inset-0 grid-pattern-dark" aria-hidden="true" />
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-bright/10 blur-3xl" aria-hidden="true" />
      <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-teal/10 blur-3xl" aria-hidden="true" />
      <div className="container-site relative">
        <nav aria-label="Breadcrumb" className="mb-6">
          <ol className="flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.15em] text-slate-400">
            <li>
              <Link to="/" data-testid="breadcrumb-home" className="hover:text-teal transition-colors">Home</Link>
            </li>
            <li aria-hidden="true"><ChevronRight size={12} /></li>
            <li aria-current="page" className="text-teal" data-testid="breadcrumb-current">{breadcrumb}</li>
          </ol>
        </nav>
        <Reveal>
          <p className="eyebrow-light mb-4">{eyebrow}</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-white max-w-3xl">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-300 max-w-2xl">{description}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
